import React, { Component } from 'react';  
import RiskEvaluationPie from './RiskEvaluationPie.js';
import { connect } from 'react-redux';
import { riskEvaluationPieData, getRiskEvaluationPieData } from "../../action/investmentAction.js";
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';
import NullView from "../NullView.js";
import { Toast } from 'antd-mobile/lib';

class RecoQuestionDoing extends Component { 
  state = {
    count: 1,
    fadeAnim2: window.winWidth,
    fadeAnim3: window.winWidth,
    fadeAnim4: window.winWidth,
    fadeAnim5: window.winWidth,
    fadeAnim6: window.winWidth,
    multieArray: [],
    answers: []
  } 

  loseLocation = () => {
    window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评", "答题页跳过"]);
    hashHistory.replace({
      pathname: "/"
    });
  }

  componentWillMount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评", "进入"]);
    document.getElementsByTagName('title')[0].innerHTML = "风险偏好测评";
    let { dispatch } = this.props;
    let array = [{
      answerNo: "9001",
      optionNo: "90005"
    },
    {
      answerNo: "9002",
      optionNo: "90013"
    },
    {
      answerNo: "9003",
      optionNo: "90023"
    },
    {
      answerNo: "9004",
      optionNo: "90041"
    },
    {
      answerNo: "9005",
      optionNo: "90055"
    },
    {
      answerNo: "9006",
      optionNo: "90065"
    }];
    Toast.loading("正在加载");
    dispatch(getRiskEvaluationPieData({answers: JSON.stringify(array)}, () => {
      Toast.hide();
    }));
  }

  componentDidMount() {
    document.body.scrollTo(0, 0);
  }
  componentWillUnmount(){
    window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评", "退出"]);
    this.props.dispatch(riskEvaluationPieData(null));
  }
  goBack = () => {
    window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评", "答题页回退"]);
    hashHistory.goBack();
  }

  passThis = () => {
    hashHistory.push({
      pathname: "/nullView"
    });
  }

  answerFun = (question, answer, count) => {
    window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评", "答题"]);
    let interVal;
    let { dispatch } = this.props;
    this.setState({
      count: count
    });
    let answersArr = [].concat(this.state.answers);
    answersArr.push({
      answerNo: question,
      optionNo: answer
    });
    let thisO = this;
    dispatch(riskEvaluationPieData(null));
    Toast.loading("正在加载");
    dispatch(getRiskEvaluationPieData({answers: JSON.stringify(answersArr)}, () => {
      this.setState({
        answers: answersArr
      });
      if(count == 7) {
        window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评", "答题结束"]);
        hashHistory.push({
          pathname: "/recoQuestionFinish",
          state: {
            riskEvaluationPieData: this.props.riskEvaluationPieData
          }
        });
      }
      Toast.hide();
    })); 
    if(count != 7) { 
      if(count == 2) {
        interVal = setInterval(() => {
          if(this.state.fadeAnim2 - 30 <= 0) {
            clearInterval(interVal);
            thisO.setState({
              fadeAnim2: 0
            });
          }else{
            thisO.setState({
              fadeAnim2: this.state.fadeAnim2 - 30
            });
          }
        }, 1);
      }else if(count == 3) {
        interVal = setInterval(() => {
          if(this.state.fadeAnim3 - 30 <= 0) {
            clearInterval(interVal);
            thisO.setState({
              fadeAnim3: 0
            });
          }else{
            thisO.setState({
              fadeAnim3: this.state.fadeAnim3 - 30
            });
          }
        }, 1);
      }else if(count == 4) {
        interVal = setInterval(() => {
          if(this.state.fadeAnim4 - 30 <= 0) {
            clearInterval(interVal);
            thisO.setState({
              fadeAnim4: 0
            });
          }else{
            thisO.setState({
              fadeAnim4: this.state.fadeAnim4 - 30
            });
          }
        }, 1);
      }else if(count == 5) {
        interVal = setInterval(() => {
          if(this.state.fadeAnim5 - 30 <= 0) {
            clearInterval(interVal);
            thisO.setState({
              fadeAnim5: 0
            });
          }else{
            thisO.setState({
              fadeAnim5: this.state.fadeAnim5 - 30
            });
          }
        }, 1);
      }else if(count == 6) {
        interVal = setInterval(() => {
          if(this.state.fadeAnim6 - 30 <= 0) {
            clearInterval(interVal);
            thisO.setState({
              fadeAnim6: 0
            });
          }else{
            thisO.setState({
              fadeAnim6: this.state.fadeAnim6 - 30
            });
          }
        }, 1);
      }
    }
  }

  render() { 
    let { count, fadeAnim2, fadeAnim3, fadeAnim4, fadeAnim5, fadeAnim6 } = this.state; 
    let { riskEvaluationPieData } = this.props;
    let roundView = [];
    for(var i = 1; i <= 6; i ++) {
      if(count == 7) {
        if(i == 6) {
          roundView.push(
            <div key={i} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
              <div style={{width: window.winWidth == 320 ? 6 : 11, height: window.winWidth == 320 ? 6 : 11, borderRadius: 11, backgroundColor: "#ff9536" }}></div>
            </div>
          );
        }else {
          roundView.push(
            <div key={i} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
              <div style={{width: window.winWidth == 320 ? 6 : 11, height: window.winWidth == 320 ? 6 : 11, borderRadius: 11, backgroundColor: "#ff9536" }}></div>
              <div style={{backgroundColor: "#ff9536", height: 1, width: window.winWidth == 320 ? 30 : 38, marginLeft: 9, marginRight: 9}}></div>
            </div>
          );
        }
      }else {
        if(i == 6) {
          if(i == count) {
            roundView.push(
              <div key={6} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                <div style={{display: "-webkit-flex", border: "1px solid #ff9536", width: window.winWidth == 320 ? 10 : 15, height: window.winWidth == 320 ? 10 : 15, borderRadius: 15, backgroundColor: "transparent", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <div style={{width: window.winWidth == 320 ? 4 : 7, height: window.winWidth == 320 ? 4 : 7, backgroundColor: "#ff9536", borderRadius: 7}}></div>
                </div>
              </div>
            );
          }else if(i > count) {
            roundView.push(
              <div key={6} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                <div style={{width: window.winWidth == 320 ? 6 : 11, height: window.winWidth == 320 ? 6 : 11, borderRadius: 11, backgroundColor: "#eef2f8" }}></div>
              </div>
            );
          }
        }else {
          if(i == count) {
            roundView.push(
              <div key={i} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                <div style={{display: "-webkit-flex", border: "1px solid #ff9536", width: window.winWidth == 320 ? 10 : 15, height: window.winWidth == 320 ? 10 : 15, borderRadius: 15, backgroundColor: "transparent", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <div style={{width: window.winWidth == 320 ? 4 : 7, height: window.winWidth == 320 ? 4 : 7, backgroundColor: "#ff9536", borderRadius: 7}}></div>
                </div>
                <div style={{backgroundColor: "#eef2f8", height: 1, width: window.winWidth == 320 ? 30 : 38, marginLeft: 9, marginRight: 9}}></div>
              </div>
            );
          }else if(i > count) {
            roundView.push(
              <div key={i} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                <div style={{width: window.winWidth == 320 ? 6 : 11, height: window.winWidth == 320 ? 6 : 11, borderRadius: 11, backgroundColor: "#eef2f8" }}></div>
                <div style={{backgroundColor: "#eef2f8", height: 1, width: window.winWidth == 320 ? 30 : 38, marginLeft: 9, marginRight: 9}}></div>
              </div>
            );
          }else if(i < count) {
            roundView.push(
              <div key={i} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                <div style={{width: window.winWidth == 320 ? 6 : 11, height: window.winWidth == 320 ? 6 : 11, borderRadius: 11, backgroundColor: "#ff9536" }}></div>
                <div style={{backgroundColor: "#ff9536", height: 1, width: window.winWidth == 320 ? 30 : 38, marginLeft: 9, marginRight: 9}}></div>
              </div>
            );
          }
        }
      }
    }
    return (  
      <div className="mainBox"> 
        <NavigatorMain>
          <div className="boxHeader">
            <div>
              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div>
              <span>风险偏好测评</span>
            </div>
            <div>
              <span onClick={this.passThis}>跳过</span>
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent">
          <div style={{height: 320}}>
            {
              riskEvaluationPieData != null ? 
              <RiskEvaluationPie dataSource={riskEvaluationPieData} /> : 
              null
            }
          </div>
          <div style={{backgroundColor: "#fff", height: 305}}>
            <div style={{display: "-webkit-flex", height: 55, WebkitFlexDirection: "row", paddingLeft: 13, paddingRight: 13, border: "1px solid rgba(242,245,247,1)", WebkitAlignItems: "center", WebkitJustifyContent: "center", WebkitFlex: 1}}>
              {
                roundView
              }
            </div>
            <div style={{paddingTop: 20, position: "relative", height: 250}}>
            {/*问题1*/}
              <div style={{backgroundColor: "#fff", position: "absolute", width: window.winWidth,  height: 250, left: 0, top: 0 ,paddingTop: 20}}>
                <div style={{display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center"}}>
                  <div style={{fontSize: 14, color: "#fa063a"}}>我今年</div>
                </div>
                <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-around", marginTop: 40}}>
                  <div 
                  onClick={() => this.answerFun("9001", "90001", 2)}
                  style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(253, 242, 231)"}}>
                    <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor:"#fea662"}}>
                      <div style={{color: "#fff", fontSize: 12}}>不到25岁</div>
                    </div>
                  </div>
                  <div 
                  onClick={() => this.answerFun("9001", "90002", 2)}
                  style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(254, 224, 224)"}}>
                    <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor:"#ff6562"}}>
                      <div style={{color: "#fff", fontSize: 12}}>26-45岁</div>
                    </div>
                  </div>
                  <div 
                  onClick={() => this.answerFun("9001", "90003", 2)}
                  style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(228, 239, 253)"}}>
                    <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor:"#6b9ef4"}}>
                      <div style={{color: "#fff", fontSize: 12}}>46-64岁</div>
                    </div>
                  </div>
                  <div 
                  onClick={() => this.answerFun("9001", "90004", 2)}
                  style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(220, 245, 252)"}}>
                    <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor:"#4ac9f5"}}>
                      <div style={{color: "#fff", fontSize: 12}}>65岁以上</div>
                    </div>
                  </div>
                </div>
              </div>
            {/*问题2*/}
              <div
              style={{backgroundColor: "#fff", position: "absolute", width: window.winWidth,  height: 250, left: this.state.fadeAnim2, top: 0 ,paddingTop: 20}}
              >
                <div style={{display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center"}}>
                  <div style={{fontSize: 14, color: "#fa063a"}}>我现在</div>
                </div>
                <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-around", marginTop: 40}}>
                  <div onClick={() => this.answerFun("9002", "90011", 3)} style={{display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150}}>
                    <div>
                      <img
                      alt=""
                      src={require("../../img/xqgz.png")}
                      style={{width: 93, height: 93}}
                      />
                    </div>
                    <div style={{color: "#5b6370", fontSize: 12, marginTop: 10}}>辛勤工作</div>
                  </div>
                  <div onClick={() => this.answerFun("9002", "90012", 3)} style={{display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150}}>
                    <div>
                      <img
                      alt=""
                      src={require("../../img/xfzj.png")}
                      style={{width: 93, height: 93}}
                      />
                    </div>
                    <div style={{color: "#5b6370", fontSize: 12, marginTop: 10}}>闲赋在家</div>
                  </div>
                </div>
              </div>
            {/*问题3*/}
              <div
              style={{backgroundColor: "#fff", position: "absolute", width: window.winWidth,  height: 250, left: this.state.fadeAnim3, top: 0, paddingTop: 20}}
              >
                <div style={{display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center"}}>
                  <div style={{fontSize: 14, color: "#fa063a"}}>我的财务状况</div>
                </div>
                <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-around", marginTop: 40}}>
                  <div onClick={() => this.answerFun("9003", "90021", 4)} style={{display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150}}>
                    <div>
                      <img
                      alt=""
                      src={require("../../img/rchx.png")}
                      style={{width: 93, height: 93}}
                      />
                    </div>
                    <div style={{color: "#5b6370", fontSize: 12, marginTop: 10}}>工资足以支付日常花销</div>
                  </div>
                  <div onClick={() => this.answerFun("9003", "90022", 4)} style={{display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150}}>
                    <div>
                      <img
                      alt=""
                      src={require("../../img/tzzj.png")}
                      style={{width: 93, height: 93}}
                      />
                    </div>
                    <div style={{color: "#5b6370", fontSize: 12, marginTop: 10}}>有时需要使用投资资金</div>
                  </div>
                </div>
              </div>
            {/*问题4*/}
              <div
              style={{backgroundColor: "#fff", position: "absolute", width: window.winWidth,  height: 250, left: this.state.fadeAnim4, top: 0, paddingTop: 20}}
              >
                <div style={{display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center"}}>
                  <div style={{fontSize: 14, color: "#fa063a"}}>我投资是为了</div>
                </div>
                <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-around", marginTop: 20, WebkitFlexWrap: "wrap"}}>
                  <div 
                  onClick={() => this.answerFun("9004", "90031", 5)}
                  style={{display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(254, 242, 231)"}}>
                    {
                      this.state.multieArray && this.state.multieArray.indexOf("资本保值") != -1 ?
                      <img
                      alt=""
                      style={{display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}
                      src={require("../../img/selectRound.png")}
                      >
                        <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#fea662"}}>
                          <div style={{color: "#fff", fontSize: 12}}>资本保值</div>
                        </div>
                      </img> :
                      <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#fea662"}}>
                        <div style={{color: "#fff", fontSize: 12}}>资本保值</div>
                      </div>
                    }
                  </div>
                  <div 
                  onClick={() => this.answerFun("9004", "90032", 5)}
                  style={{display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(254, 222, 219)"}}>
                    {
                      this.state.multieArray && this.state.multieArray.indexOf("累积财富") != -1 ?
                      <img
                      alt=""
                      style={{display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}
                      src={require("../../img/selectRound.png")}
                      >
                        <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#ff6562"}}>
                          <div style={{color: "#fff", fontSize: 12}}>累积财富</div>
                        </div>
                      </img> :
                      <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#ff6562"}}>
                        <div style={{color: "#fff", fontSize: 12}}>累积财富</div>
                      </div>
                    }
                  </div>
                  <div 
                  onClick={() => this.answerFun("9004", "90033", 5)}
                  style={{display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(227, 236, 250)"}}>
                    {
                      this.state.multieArray && this.state.multieArray.indexOf("日常收入") != -1 ?
                      <img
                      alt=""
                      style={{display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}
                      src={require("../../img/selectRound.png")}
                      >
                        <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#6b9ef4"}}>
                          <div style={{color: "#fff", fontSize: 12}}>日常收入</div>
                        </div>
                      </img> :
                      <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#6b9ef4"}}>
                        <div style={{color: "#fff", fontSize: 12}}>日常收入</div>
                      </div>
                    }
                  </div>
                  <div 
                  onClick={() => this.answerFun("9004", "90034", 5)}
                  style={{display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(220, 245, 252)"}}>
                    {
                      this.state.multieArray && this.state.multieArray.indexOf("投机") != -1 ?
                      <img
                      alt=""
                      style={{display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}
                      src={require("../../img/selectRound.png")}
                      >
                        <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#4ac9f5"}}>
                          <div style={{color: "#fff", fontSize: 12}}>投机</div>
                        </div>
                      </img> :
                      <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#4ac9f5"}}>
                        <div style={{color: "#fff", fontSize: 12}}>投机</div>
                      </div>
                    }
                  </div>
                  <div 
                  onClick={() => this.answerFun("9004", "90035", 5)}
                  style={{display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(253, 242, 231)"}}>
                    {
                      this.state.multieArray && this.state.multieArray.indexOf("战胜通胀") != -1 ?
                      <img
                      alt=""
                      style={{display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}
                      src={require("../../img/selectRound.png")}
                      >
                        <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#fea662"}}>
                          <div style={{color: "#fff", fontSize: 12}}>战胜通胀</div>
                        </div>
                      </img> :
                      <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#fea662"}}>
                        <div style={{color: "#fff", fontSize: 12}}>战胜通胀</div>
                      </div>
                    }
                  </div>
                  <div 
                  onClick={() => this.answerFun("9004", "90036", 5)}
                  style={{display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(225, 248, 227)"}}>
                    {
                      this.state.multieArray && this.state.multieArray.indexOf("对冲") != -1 ?
                      <img
                      alt=""
                      style={{display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}
                      src={require("../../img/selectRound.png")}
                      >
                        <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#68dd6e"}}>
                          <div style={{color: "#fff", fontSize: 12}}>对冲</div>
                        </div>
                      </img> :
                      <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#68dd6e"}}>
                        <div style={{color: "#fff", fontSize: 12}}>对冲</div>
                      </div>
                    }
                  </div>
                  <div 
                  onClick={() => this.answerFun("9004", "90037", 5)}
                  style={{display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(219, 248, 251)"}}>
                    {
                      this.state.multieArray && this.state.multieArray.indexOf("主营业务") != -1 ?
                      <img
                      alt=""
                      style={{display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}
                      src={require("../../img/selectRound.png")}
                      >
                        <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#4ed7f0"}}>
                          <div style={{color: "#fff", fontSize: 12}}>主营业务</div>
                        </div>
                      </img> :
                      <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#4ed7f0"}}>
                        <div style={{color: "#fff", fontSize: 12}}>主营业务</div>
                      </div>
                    }
                  </div>
                  <div 
                  onClick={() => this.answerFun("9004", "90038", 5)}
                  style={{display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(235, 235, 250)"}}>
                    {
                      this.state.multieArray && this.state.multieArray.indexOf("继承遗产") != -1 ?
                      <img
                      alt=""
                      style={{display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}
                      src={require("../../img/selectRound.png")}
                      >
                        <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#9f95e6"}}>
                          <div style={{color: "#fff", fontSize: 12}}>继承遗产</div>
                        </div>
                      </img> :
                      <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#9f95e6"}}>
                        <div style={{color: "#fff", fontSize: 12}}>继承遗产</div>
                      </div>
                    }
                  </div>
                  <div 
                  onClick={() => this.answerFun("9004", "90039", 5)}
                  style={{display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(253, 222, 220)"}}>
                    {
                      this.state.multieArray && this.state.multieArray.indexOf("退休养老") != -1 ?
                      <img
                      alt=""
                      style={{display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}
                      src={require("../../img/selectRound.png")}
                      >
                        <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#ff5c50"}}>
                          <div style={{color: "#fff", fontSize: 12}}>退休养老</div>
                        </div>
                      </img> :
                      <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#ff5c50"}}>
                        <div style={{color: "#fff", fontSize: 12}}>退休养老</div>
                      </div>
                    }
                  </div>
                  <div 
                  onClick={() => this.answerFun("9004", "90040", 5)}
                  style={{display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(248, 230, 245)"}}>
                    {
                      this.state.multieArray && this.state.multieArray.indexOf("子女教育") != -1 ?
                      <img
                      alt=""
                      style={{display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}
                      src={require("../../img/selectRound.png")}
                      >
                        <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#f580a0"}}>
                          <div style={{color: "#fff", fontSize: 12}}>子女教育</div>
                        </div>
                      </img> :
                      <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor:"#f580a0"}}>
                        <div style={{color: "#fff", fontSize: 12}}>子女教育</div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            {/*问题5*/}
              <div
              style={{backgroundColor: "#fff", position: "absolute", width: window.winWidth,  height: 250, left: this.state.fadeAnim5, top: 0 ,paddingTop: 20}}
              >
                <div style={{display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center"}}>
                  <div style={{fontSize: 14, color: "#fa063a"}}>我可以承受的损失</div>
                </div>
                <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-around", marginTop: 40}}>
                  <div onClick={() => this.answerFun("9005", "90051", 6)} style={{display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150}}>
                    <div>
                      <img
                      alt=""
                      src={require("../../img/money1.png")}
                      style={{width: 70, height: 70}}
                      />
                    </div>
                    <div style={{color: "#5b6370", fontSize: 12, marginTop: 10}}>{"<15%"}</div>
                    <div style={{color: "#5b6370", fontSize: 12, marginTop: 10}}>(精打细算)</div>
                  </div>
                  <div onClick={() => this.answerFun("9005", "90052", 6)} style={{display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150}}>
                    <div>
                      <img
                      alt=""
                      src={require("../../img/money2.png")}
                      style={{width: 70, height: 70}}
                      />
                    </div>
                    <div style={{color: "#5b6370", fontSize: 12, marginTop: 10}}>{"15-25%"}</div>
                    <div style={{color: "#5b6370", fontSize: 12, marginTop: 10}}>(追求稳健)</div>
                  </div>
                  <div onClick={() => this.answerFun("9005", "90053", 6)} style={{display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150}}>
                    <div>
                      <img
                      alt=""
                      src={require("../../img/money3.png")}
                      style={{width: 70, height: 70}}
                      />
                    </div>
                    <div style={{color: "#5b6370", fontSize: 12, marginTop: 10}}>{"25-50%"}</div>
                    <div style={{color: "#5b6370", fontSize: 12, marginTop: 10}}>(财大气粗)</div>
                  </div>
                  <div onClick={() => this.answerFun("9005", "90054", 6)} style={{display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150}}>
                    <div>
                      <img
                      alt=""
                      src={require("../../img/money4.png")}
                      style={{width: 70, height: 70}}
                      />
                    </div>
                    <div style={{color: "#5b6370", fontSize: 12, marginTop: 10}}>{">50%"}</div>
                    <div style={{color: "#5b6370", fontSize: 12, marginTop: 10}}>(有钱任性)</div>
                  </div>
                </div>
              </div>
            {/*问题6*/}
              <div
              style={{backgroundColor: "#fff", position: "absolute", width: window.winWidth,  height: 250, left: this.state.fadeAnim6, top: 0 ,paddingTop: 20}}
              >
                <div style={{display: "-webkit-flex", WebkitAlignItems: "center", paddingLeft: 13, paddingRight: 13, WebkitJustifyContent: "center"}}>
                  <div style={{fontSize: 14, color: "#fa063a"}}>如果以50%收益为投资目标，您认为多久能实现目标？</div>
                </div>
                <div style={{display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-around", marginTop: 40}}>
                  <div 
                  onClick={() => this.answerFun("9006", "90061", 7)}
                  style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(253, 242, 231)"}}>
                    <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor:"#fea662"}}>
                      <div style={{color: "#fff", fontSize: 12}}>10年以上</div>
                    </div>
                  </div>
                  <div 
                  onClick={() => this.answerFun("9006", "90062", 7)}
                  style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(254, 224, 224)"}}>
                    <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor:"#ff6562"}}>
                      <div style={{color: "#fff", fontSize: 12}}>6-10年</div>
                    </div>
                  </div>
                  <div 
                  onClick={() => this.answerFun("9006", "90063", 7)}
                  style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(228, 239, 253)"}}>
                    <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor:"#6b9ef4"}}>
                      <div style={{color: "#fff", fontSize: 12}}>1-5年</div>
                    </div>
                  </div>
                  <div 
                  onClick={() => this.answerFun("9006", "90064", 7)}
                  style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(220, 245, 252)"}}>
                    <div style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor:"#4ac9f5"}}>
                      <div style={{color: "#fff", fontSize: 12}}>1年以内</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
    );  
  }  
}  

function mapStateToProps(state, ownProps) {
  return {
    riskEvaluationPieData: state.riskEvaluationPieData
  }
}
  
export default connect(mapStateToProps)(RecoQuestionDoing);


// WEBPACK FOOTER //
// ./src/components/recommend/RecoQuestionDoing.js